import React, { useState, useEffect } from "react";
// import * as Yup from "yup";
import { toast } from "react-toastify";
import Hoc from "../../../components/HOC";
// import ModalComponent from "../../../components/Modal";
import CustomDataTable from "../../../components/CustomDataTable";
import { MdDelete, MdEdit } from "react-icons/md";
import AddClientModal from "./AddClientModal";
import { useDispatch, useSelector } from "react-redux";
import {
  setResetStateClientsList,
  requestClientAction,
  requestClientsListAction,
  setResetStateClient,
  setResetEditClient,
  requestEditClient,
  setResetStateClientById,
  requestClientById,
} from "../../../Redux/ClientState/ClientActionCreator";
import Loader from "../../../components/Loader";

const AddClient = () => {
  const [isModalOpen, setIsModalOpen] = useState({ title: "", isOpen: false });
  const dispatch = useDispatch();
  const clientsListState = useSelector((state) => state.ClientsListReducer);
  const addClientReducer = useSelector((state) => state.ClientReducer);
  const editClientReducer = useSelector((state) => state.EditClientReducer);
  const clientByIdReducer = useSelector((state) => state.ClientByIdReducer);
  const [search, setSearch] = useState("");
  // const [editData,setEditData]=useState({name: "",
  //   addressLine1: "",
  //   addressLine2: "",
  //   city: "",
  //   state: "",
  //   country: "",
  //   zip: "",});

  const initialValues = {
    name: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "USA",
    zip: "",
  };

  const columns = [
    {
      name: "Client Name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <span className="text-md font-medium">
          {row.name}
        </span>
      ),
    },
    {
      name: "Client Email",
      selector: (row) => row.email,
      sortable: true,
      hide: "sm",
      cell: (row) => (
        <span className="text-md font-medium truncate">
          {row.email}
        </span>
      ),
       minWidth: "250px"
    },
    {
      name: "Address Line1",
      selector: (row) => row.addressLine1,
      sortable: true,
      hide: "sm",
      cell: (row) => (
        <span className="text-md font-medium truncate">
          {row.addressLine1}
        </span>
      ),
       minWidth: "200px"
    },
    // {
    //   name: "Address Line2",
    //   selector: (row) => row.addressLine2,
    //   sortable: true,
    // },
    {
      name: "City",
      selector: (row) => row.city,
      sortable: true,
      hide: "sm"
    },
    {
      name: "State",
      selector: (row) => row.state,
      sortable: true,
      hide: "sm"
    },
    // {
    //   name: "Country",
    //   selector: (row) => row.country,
    //   sortable: true,
    // },
    {
      name: "Zip",
      selector: (row) => row.zip,
      sortable: true,
      hide:"sm"
    },
    // {
    //   name: 'Address',
    //   // selector: row =>`${row.address}, ${row.city}, ${row.state},${row.country}`,
    //   selector: row => row.address,
    //   sortable: true,
    // },

    {
      name: "Actions",
      cell: (row, index) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(row)}
            className="text-primary hover:text-primaryDark"
          >
            <MdEdit size={24} />
          </button>
        </div>
      ),
      minWidth: "20px"
      
    },

  ]; 

  const handleEdit = (row) => {
    dispatch(setResetStateClient());
    dispatch(requestClientById(row.id));
    setIsModalOpen({ title: "Edit Client", isOpen: true });
  };

  const handleAddClient = (values) => {
    if (isModalOpen.title === "Add Client") {
      dispatch(requestClientAction(values));
    } else {
      dispatch(
        requestEditClient({
          id: clientByIdReducer?.byIdResponse?.id,
          data: values,
        })
      );
    }
  };

  const handleDelete = (idToDelete) => {};

  const handlePageChange = (page) => {
    dispatch(
      requestClientsListAction({
        page: page,
        size: clientsListState?.size,
        search: search,
      })
    );
  };

  const handleRowsChange = (size) => {
    dispatch(requestClientsListAction({ page: 0, size: size, search: search }));
  };
  const handleClose = () => {
    setIsModalOpen({ title: "", isOpen: false });
    dispatch(setResetEditClient());
    dispatch(setResetStateClientById());
  };

  useEffect(() => {
    dispatch(setResetStateClientsList());
    dispatch(
      requestClientsListAction({
        page: clientsListState?.page,
        size: clientsListState?.size,
      })
    );
    dispatch(setResetStateClient());
    dispatch(setResetStateClientById());
    dispatch(setResetEditClient());
  }, []);

   useEffect(() => {
      if (clientsListState?.error && !clientsListState?.loading) {
        toast.error("No clients found / something went wrong");
        dispatch(setResetStateClientsList());
      }
    }, [clientsListState]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(
        requestClientsListAction({
          page: 0,
          size: clientsListState?.size,
          search: search,
        })
      );
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search]);

  useEffect(() => {
    if (!addClientReducer?.isLoading && addClientReducer?.isResponse) {
      toast.success("Client added successfully");
      dispatch(setResetStateClient());
      dispatch(
        requestClientsListAction({
          page: clientsListState?.page,
          size: clientsListState?.size,
        })
      );
      setSearch("");
      handleClose();
      // dispatch(setResetStateClient());
    } else if (!addClientReducer?.isLoading && addClientReducer?.isError) {
      toast.error("Error adding client");
      dispatch(setResetStateClient());
    }
  }, [addClientReducer]);

  useEffect(() => {
    if (!clientByIdReducer?.byIdLoading && clientByIdReducer?.byIdResponse) {
      setIsModalOpen({ title: "Edit Client", isOpen: true });
    } else if (
      !clientByIdReducer?.byIdLoading &&
      clientByIdReducer?.byIdError
    ) {
      toast.error("Error fetching client data");
      dispatch(setResetStateClientById());
    }
  }, [clientByIdReducer]);

  useEffect(() => {
    if (!editClientReducer?.Loading && editClientReducer?.Response) {
      toast.success("Client updated successfully");
      dispatch(
        requestClientsListAction({
          page: clientsListState?.page,
          size: clientsListState?.size,
          search: ""
        })
      );
      setSearch("");
      handleClose();
      dispatch(setResetEditClient());
    } else if (!editClientReducer?.Loading && editClientReducer?.Error) {
      toast.error("Error updating client");
      dispatch(setResetEditClient());
    }
  }, [editClientReducer]); 

  const handleClick = () => {
    setIsModalOpen({ title: "Add Client", isOpen: true });
  };

  return (
    <div className="p-6 w-full h-[90vh] overflow-y-scroll">
      <Loader
        isLoading={clientsListState?.loading || clientByIdReducer?.byIdLoading}
      />
      <div className="absolute flex  mb-4 z-10 right-6">
        {/* <button
          onClick={handleClick}
          className="flex items-center cursor-pointer float-right justify-center bg-primary hover:bg-primaryDark text-white py-2 px-4 rounded-full shadow-md transition-all duration-300"
        >
          <span className="text-xl cursor-pointer font-extrabold">+</span>
        </button> */}
         <button
          onClick={handleClick}
          className="flex items-center justify-center bg-primary hover:bg-primaryDark text-white py-1 px-6 mr-4 rounded-full shadow-lg transition-all duration-300"
        >
          <span className="text-2xl font-medium">+</span>
        </button>
      </div>
      <CustomDataTable
        columns={columns}
        data={clientsListState?.response?.content}
        onDelete={handleDelete}
        enableSearch={true}
        search={search}
        setSearch={setSearch}
        serverPagenation
        paginationTotalRows={clientsListState?.response?.totalElements}
        handleChangePage={handlePageChange}
        handleRowsChange={handleRowsChange}
        fixedHeaderScrollHeight={"65vh"}
      />

      <AddClientModal
        initialValues={
          isModalOpen.title === "Add Client"
            ? initialValues
            : clientByIdReducer.byIdResponse
        }
        show={isModalOpen.isOpen}
        onClose={handleClose}
        title={isModalOpen.title}
        onAddClient={handleAddClient}
      />
    </div>
  );
};

export default Hoc(AddClient);
